import { createFileRoute } from "@tanstack/react-router";
import AetnaMarketplaceInsurance, {
  config,
} from "@/pages/AetnaMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/aetna-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Aetna Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have an Aetna Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan.",
        },
        {
          property: "og:title",
          content: "Aetna Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have an Aetna Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/aetna-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/aetna-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AetnaMarketplaceInsurance />;
}
